// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3vwgW","emails":"CreateEditClinics_emails__3dmpH","emailTagLabel":"CreateEditClinics_emailTagLabel__1S07N"};